import {
  returnAllTradeDetailsFromGenericParams,
  returnOPLegFormThisTrade,
  returnRPLegFromThisTrade,
} from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnSizeFormatted } from "@/lib/globalFormatterHelper";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import tradeDataStore from "@/store/tradeDataStore";

interface ResolvedNotional {
  notionalLeg1: number;
  instrumentType?: string;
}

function resolveNotional(
  params: any,
  thisTrade: ExecutionStrategy | undefined,
): ResolvedNotional | undefined {
  const { isOp, isER, isLeg, isOutright } =
    returnAllTradeDetailsFromGenericParams(params);

  const leg = thisTrade
    ? isOp
      ? returnOPLegFormThisTrade({
          params,
          thisTrade,
          isOp,
          isER,
          isOutright,
          isLeg,
        })
      : returnRPLegFromThisTrade({
          params,
          thisTrade,
          isOp,
          isOutright,
          isLeg,
        })
    : undefined;

  if (leg?.notionalLeg1) {
    return {
      notionalLeg1: leg.notionalLeg1,
      instrumentType: leg.instrumentType,
    };
  }

  // Fallback for historical trades or rows where the trade isn't in the store
  if (isOutright && params.data?.legs?.[0]?.notionalLeg1) {
    return {
      notionalLeg1: params.data.legs[0].notionalLeg1,
      instrumentType: params.data.legs[0].instrumentType,
    };
  }
  if (params.value) {
    return {
      notionalLeg1: params.value,
      instrumentType: params.data?.instrumentType,
    };
  }

  return undefined;
}

// Display formatter — abbreviates large numbers (e.g. "10 MM") and adds "lots" for FUT
export function formatNotionalLeg1Display(
  params: any,
  thisTrade?: ExecutionStrategy,
): string {
  const resolved = resolveNotional(params, thisTrade);
  if (!resolved) return "";
  return returnSizeFormatted(resolved.notionalLeg1, resolved.instrumentType);
}

// Raw value for copy/paste — no abbreviation, no suffix, trailing space per convention
export function formatNotionalLeg1Raw(
  params: any,
  thisTrade?: ExecutionStrategy,
): string {
  const resolved = resolveNotional(params, thisTrade);
  if (!resolved) return "";
  return `${resolved.notionalLeg1} `;
}

export function notionalLeg1ValueFormatter(params: any): string {
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const currentTradeData = tradeDataStore.getState().tradeData;
  const thisTrade = currentTradeData.find(
    (trade) => trade.esid === fullTradeData.esid,
  );

  return formatNotionalLeg1Raw(params, thisTrade);
}
